import React from 'react';
import { Box, Drawer, DrawerContent, DrawerOverlay, IconButton, Text } from '@chakra-ui/react';
import { Close } from '@mui/icons-material';

// Right-hand drawer that floats on desktop (inset 20px, radius 16, drawer shadow) and goes full screen
// on phones (design-system.md §4.6). `footer` sticks to the bottom.
const FloatingDrawer = ({ isOpen, onClose, title, width = '500px', footer, children, initialFocusRef, label }) => (
    <Drawer isOpen={isOpen} placement='right' onClose={onClose} initialFocusRef={initialFocusRef} >
        <DrawerOverlay bg='blackAlpha.400' />
        <DrawerContent
            aria-label={label}
            maxWidth={{ base: '100vw', md: width }}
            width={{ base: '100vw', md: width }}
            sx={{ '@media (min-width: 750px)': { margin: '20px', height: 'calc(100% - 40px) !important', borderRadius: '16px', overflow: 'hidden' } }}
            boxShadow='drawer'
        >
            {title &&
                <Box display='flex' alignItems='center' justifyContent='space-between' height='60px' px={{ base: '16px', md: '20px' }} borderBottom='1px solid' borderColor='raano.border' flexShrink={0} >
                    {typeof title === 'string' ? <Text fontSize='16px' fontWeight={600} >{title}</Text> : title}
                    <IconButton variant='ghost' aria-label='Close' icon={<Close />} onClick={onClose} mr='-8px' />
                </Box>}
            <Box flex={1} overflowY='auto' >{children}</Box>
            {footer && <Box flexShrink={0} borderTop='1px solid' borderColor='raano.border' px={{ base: '16px', md: '20px' }} pt='14px' pb={{ base: 'calc(14px + env(safe-area-inset-bottom))', md: '16px' }} >{footer}</Box>}
        </DrawerContent>
    </Drawer>
);

export default FloatingDrawer;
